import React from 'react';

import { useApiGet, useApiLoading } from 'react-reqq-lite';

import * as actions from './actions';
import * as c from './constants';

// TAX CHARGES

export const useGetTaxCharges = (params, cb, { disableAction } = {}) => {
  const isApiLoading = useApiLoading(c.GET_TAX_CHARGES, 'get');
  const list = useApiGet(`${c.GET_TAX_CHARGES}.list`, []);
  const pagination = useApiGet(`${c.GET_TAX_CHARGES}.pagination`, {});

  React.useEffect(() => {
    if (disableAction) return;

    actions.getTaxCharges(params, cb);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(params), disableAction]);

  return [isApiLoading, list, pagination];
};

// VAT

export const useGetVAT = (params, cb) => {
  const isApiLoading = useApiLoading(c.GET_VAT, 'get');
  const data = useApiGet(c.GET_VAT, {});

  React.useEffect(() => {
    if (!params?.uuid) return;

    actions.getVAT(params, cb);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(params)]);

  return [isApiLoading, data];
};

export const useCreateVAT = () => {
  const isApiLoading = useApiLoading(c.CREATE_VAT, 'post');

  const action = React.useCallback((params, cb) => {
    actions.createVAT(params, cb);
  }, []);

  return [isApiLoading, action];
};

export const useUpdateVAT = () => {
  const isApiLoading = useApiLoading(c.UPDATE_VAT, 'put');

  const action = React.useCallback((params, cb) => {
    actions.updateVAT(params, cb);
  }, []);

  return [isApiLoading, action];
};

// EXTRA CHARGES

export const useGetExtraCharges = (params, cb, { disableAction } = {}) => {
  const isApiLoading = useApiLoading(c.GET_EXTRA_CHARGES, 'get');
  const data = useApiGet(`${c.GET_EXTRA_CHARGES}.list`, []);
  const pagination = useApiGet(`${c.GET_EXTRA_CHARGES}.pagination`, {});

  React.useEffect(() => {
    if (disableAction) return;

    actions.getExtraCharges(params, cb);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(params), disableAction]);

  return [isApiLoading, data, pagination];
};

export const useUpdateExtraCharges = () => {
  const isApiLoading = useApiLoading(c.UPDATE_EXTRA_CHARGES, 'patch');

  const action = React.useCallback((params, cb) => {
    actions.updateExtraCharges(params, cb);
  }, []);

  return [isApiLoading, action];
};

export const useRemoveExtraCharges = () => {
  const isApiLoading = useApiLoading(c.DELETE_EXTRA_CHARGES, 'remove');

  const action = React.useCallback((params, cb) => {
    actions.deleteExtraCharges(params, cb);
  }, []);

  return [isApiLoading, action];
};

// DISCOUNT

export const useGetDiscounts = (params, cb) => {
  const isApiLoading = useApiLoading(c.GET_DISCOUNTS, 'get');
  const data = useApiGet(`${c.GET_DISCOUNTS}.list`, []);
  const pagination = useApiGet(`${c.GET_DISCOUNTS}.pagination`, {});

  const refresh = React.useCallback(() => {
    actions.getDiscounts(params, cb);
  }, [params, cb]);

  React.useEffect(() => {
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(params)]);

  return [isApiLoading, data, pagination, refresh];
};

export const useCreateDiscount = () => {
  const isApiLoading = useApiLoading(c.CREATE_DISCOUNT, 'post');

  const action = React.useCallback((params, cb) => {
    actions.createDiscount(params, cb);
  }, []);

  return [isApiLoading, action];
};

export const useUpdateDiscount = () => {
  const isApiLoading = useApiLoading(c.UPDATE_DISCOUNT, 'put');

  const action = React.useCallback((params, cb) => {
    actions.updateDiscount(params, cb);
  }, []);

  return [isApiLoading, action];
};

export const useRemoveDiscount = () => {
  const isApiLoading = useApiLoading(c.REMOVE_DISCOUNT, 'remove');

  const action = React.useCallback((params, cb) => {
    actions.removeDiscount(params, cb);
  }, []);

  return [isApiLoading, action];
};
